/**
 * OracleShell
 * Oracle sayfalarını saran izole konteyner
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft, Sparkles, Home } from 'lucide-react';
import '../styles/oracle.css';

export default function OracleShell({ 
  children, 
  showBack = false, 
  onBack,
  credits,
  title = null
}) {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Breadcrumb logic
  const getBreadcrumb = () => {
    const path = location.pathname;
    if (path === '/oracle') return ['Ana Sayfa', 'Oracle'];
    if (path === '/oracle/new') return ['Ana Sayfa', 'Oracle', 'Yeni Açılım'];
    if (path.startsWith('/oracle/reading')) return ['Ana Sayfa', 'Oracle', 'Açılım'];
    return ['Ana Sayfa', 'Oracle'];
  };
  
  const breadcrumb = getBreadcrumb();
  
  return (
    <div className="oracle-shell">
      {/* Breadcrumb Navigation */}
      <div className="oracle-breadcrumb" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 20px',
        background: 'rgba(0,0,0,0.2)',
        borderBottom: '1px solid rgba(255,255,255,0.05)'
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '8px',
            padding: '6px 12px',
            color: 'rgba(255,255,255,0.7)',
            cursor: 'pointer',
            fontSize: '13px',
            transition: 'all 0.2s'
          }}
        >
          <Home size={14} />
          <span>Dashboard</span>
        </button>
        
        <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: '12px' }}>›</span>
        
        {breadcrumb.slice(1).map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: '12px' }}>›</span>}
            <span style={{ 
              color: index === breadcrumb.length - 2 ? '#c084fc' : 'rgba(255,255,255,0.5)',
              fontSize: '13px',
              fontWeight: index === breadcrumb.length - 2 ? '500' : '400'
            }}>
              {item}
            </span>
          </React.Fragment>
        ))}
      </div>
      
      {/* Header */}
      <header className="oracle-header">
        <div>
          {showBack && onBack ? (
            <button className="oracle-back-btn" onClick={onBack}>
              <ChevronLeft size={20} />
              <span>Geri</span>
            </button>
          ) : (
            <div style={{ width: 60 }} />
          )}
        </div>
        
        {title && (
          <h1 style={{ fontSize: 16, fontWeight: 600 }}>{title}</h1>
        )}
        
        {credits !== undefined && (
          <div className="oracle-credits">
            <Sparkles size={16} />
            <span>{credits}</span>
          </div>
        )}
      </header>
      
      {/* Content */}
      <main>
        {children}
      </main>
    </div>
  );
}
